import { render, staticRenderFns } from "./Posterinfo.vue?vue&type=template&id=1b12dbdd&scoped=true&"
import script from "./Posterinfo.vue?vue&type=script&lang=js&"
export * from "./Posterinfo.vue?vue&type=script&lang=js&"
import style0 from "./Posterinfo.vue?vue&type=style&index=0&id=1b12dbdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b12dbdd",
  null
  
)

export default component.exports